import { Modal, Skeleton } from "antd";
import { useProprietarios } from "../hooks/useProprietarios";
import {
  ContainerHospedes,
  TextHospedes,
  TitleHospedes,
} from "../../ViewGerenciarReserva/styles";

export default function ModalProprietarios({
  isModalOpen,
  handleFechar,
  usuarioId,
}: any) {
  const { usuario, loading } = useProprietarios(usuarioId, isModalOpen);

  return (
    <>
      <Modal open={isModalOpen} onCancel={handleFechar} footer={null}>
        {loading && <Skeleton active />}
        {!loading && usuario && (
          <ContainerHospedes key={usuario.id}>
            <TitleHospedes>Proprietário</TitleHospedes>
            <TextHospedes>
              <span style={{ fontWeight: "bold" }}>Nome: </span>
              {usuario.nome} {usuario.sobrenome}
            </TextHospedes>
            <TextHospedes>
              <span style={{ fontWeight: "bold" }}>CPF: </span>
              {usuario.cpf}
            </TextHospedes>
            <TextHospedes>
              <span style={{ fontWeight: "bold" }}>Email: </span>
              {usuario.email}
            </TextHospedes>
            <TextHospedes>
              <span style={{ fontWeight: "bold" }}>Celular: </span>
              {usuario.celular ? usuario.celular : "Não informado"}
            </TextHospedes>
            <TextHospedes>
              <span style={{ fontWeight: "bold" }}>Nacionalidade: </span>
              {usuario.nacionalidade ? usuario.nacionalidade : "Não informado"}
            </TextHospedes>
            <TextHospedes>
              <span style={{ fontWeight: "bold" }}>Estado Civil: </span>
              {usuario.estadoCivil ? usuario.estadoCivil : "Não informado"}
            </TextHospedes>
          </ContainerHospedes>
        )}
      </Modal>
    </>
  );
}
